var _rect, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorSceneView = function SvgErrorSceneView(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 70,
    viewBox: "0 0 125 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1782_8421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 125,
    height: 70
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1782_8421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 125,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 70,
    rx: 12,
    fill: "#59C1FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1782_8421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.01,
    height: 70,
    rx: 12,
    fill: "#59C1FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1782_8421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.69336,
    y: -57.647,
    width: 285.577,
    height: 146.588,
    rx: 12,
    fill: "#242222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 10,
    fill: "#FF4D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.974 14.58H12.224V9H13.974V14.58ZM12 16.862C12 16.5633 12.0747 16.3113 12.224 16.106C12.3827 15.8913 12.672 15.784 13.092 15.784C13.5213 15.784 13.8107 15.8913 13.96 16.106C14.1187 16.3113 14.198 16.5633 14.198 16.862C14.198 17.1607 14.1187 17.4173 13.96 17.632C13.8107 17.8373 13.5213 17.94 13.092 17.94C12.672 17.94 12.3827 17.8373 12.224 17.632C12.0747 17.4173 12 17.1607 12 16.862Z",
    fill: "white",
    fillOpacity: 0.96
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorSceneView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "errorSceneView.a06ae96b56d76d8e450a438a8f61679c.svg";